import React, {useEffect} from 'react';

const Loading: React.FC = () => {
    return (
        <></>
    );
};

export default Loading;